import { cn } from '@/lib/utils'
import type { CSSProperties } from 'react'
import { Link } from 'react-router'

export type AccordionItemLinkProps = {
  className?: string
  href: string
  itemKey: string
  metaStyle?: CSSProperties
  metaText?: string
  primaryText: string
  secondaryText: string
}

export const AccordionItemLink = ({
  className,
  href,
  metaStyle,
  metaText,
  primaryText,
  secondaryText,
}: AccordionItemLinkProps) => {
  return (
    <Link
      to={href}
      className={cn(
        'block border-t border-slate-200 first:border-t-0 no-underline transition-colors hover:bg-slate-50',
        className
      )}
    >
      <div className="px-4 py-3">
        <div className="min-w-0">
          <div className="flex items-center justify-between gap-4">
            <p className="truncate text-[13px] font-semibold text-slate-800">
              {primaryText}
            </p>
            {metaText ? (
              <p
                className="shrink-0 whitespace-nowrap text-[11px] font-semibold tracking-[0.01em]"
                style={metaStyle}
              >
                {metaText}
              </p>
            ) : null}
          </div>
          <p className="mt-0.5 truncate text-[12px] text-slate-500">
            {secondaryText}
          </p>
        </div>
      </div>
    </Link>
  )
}
